const toUnderscoreCase = (str: string) => str.split(/(?=[A-Z])/).join('_').toLowerCase();

const stringDecorator = {
  toUnderscoreCase
};

export default stringDecorator;
